<template>
  <VeterConnect />
</template>

<script>
  import VeterConnect from "@/components/VeterinaireConnect.vue";
  export default {
    name: "ProductListPage",
    components: {
      VeterConnect,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
